import React, { lazy, Suspense } from 'react';

const Cookie = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import('./index.lazy')), 1500);
  });
});

const CookieSuspense = (props) => (
  <Suspense>
    <Cookie {...props} />
  </Suspense>
);

export default CookieSuspense;
